import styled from "styled-components";

export const HeaderContainer = styled.header`
  display: grid !important;
  grid-template-columns: auto 1fr auto;
  background: linear-gradient(90deg, #3b53ff 0%, #40bbff 100%);
  height: 5.5rem;
  box-shadow: 0px 0px 5px #000000e6;
  position: fixed;
  width: -webkit-fill-available;
  top: 0;
  left: 0;
  z-index: 1000;
  align-items: center;
  padding: 5px 24px;
`;

export const AreaLeft = styled.div`
  display: flex;
  align-items: center;
  margin-left: 2rem;
  margin-right: 2rem;
`;

export const AreaRight = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 2rem;

  @media screen and (max-width: 600px) {
    margin-right: 0;
  }
`;

export const StyledSVG = styled.svg`
  margin-right: 1rem;
`;

export const PanelText = styled.span`
  color: #fff;
  font-size: 1.063rem;
  font-family: "Montserrat", sans-serif;
`;

export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 600px) {
    display: flex;
    cursor: pointer;
  }
`;

export const HeaderNav = styled.nav<{ isVisible: boolean }>`
  display: flex !important;
  justify-content: flex-end;
  align-items: center;

  @media screen and (max-width: 600px) {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: calc(100vh - 103px);
    position: absolute;
    top: 5.5rem;
    left: ${({ isVisible }) => (isVisible ? "0" : "-100%")};
    opacity: 1;
    transition: all 0.5s ease;
    background: #3b53ff;
  }
`;

export const NavLink = styled.a<{ mobileOnly?: boolean }>`
  display: ${({ mobileOnly }) => (mobileOnly ? "none" : "flex !important")};
  justify-content: flex-end;
  text-decoration: none;
  font-family: Mulish, sans-serif;
  color: #fff;
  letter-spacing: 1.2px;
  transition: color 300ms ease;
  font-size: 20px;
  margin: 0 20px;
  position: relative;

  @media screen and (min-width: 601px) {
    &:last-child::after {
      content: "";
      position: absolute;
      right: -15px;
      top: 50%;
      transform: translateY(-50%);
      height: 24px;
      width: 1px;
      background-color: #fff;
    }
  }

  &:hover {
    color: rgb(182, 182, 182);
  }

  @media screen and (max-width: 600px) {
    display: flex !important;
    margin: 10px 0;
    font-size: 1.5rem;
  }
`;

export const AuthButtonsContainer = styled.div`
  display: flex;
  align-items: center;

  @media screen and (max-width: 600px) {
    display: none;
  }
`;
